import React, {Component} from 'react';
import {Table, Loader} from 'semantic-ui-react';

class TableStoragePage extends Component {
  renderLine() {
    const {loading, pendingLinesList} = this.props;
    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    if (!pendingLinesList.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={4}>No hay líneas pendientes a guardar o asignadas a usted</Table.Cell>
        </Table.Row>
      );
    }

    return pendingLinesList.map((element, index) => {
      const location = element.partLocation;
      const locationFirstPart = location.substring(0, 3);
      const locationSecondPart = location.substring(3);

      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>
            <span className='location'>
              {locationFirstPart}
            </span>
            {locationSecondPart}
          </Table.Cell>
          <Table.Cell textAlign='center'>{element.partCode}</Table.Cell>
          <Table.Cell textAlign='center'>{element.partName}</Table.Cell>
          <Table.Cell textAlign='center'>{element.quantity}</Table.Cell>
        </Table.Row>
      );
    });
  }

  render() {
    return (
      <Table>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell textAlign='center'>Ubicación</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Código Parte</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Descripción</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Cantidad</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {this.renderLine()}
        </Table.Body>
      </Table>
    );
  }
}

export default TableStoragePage;
